<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" small icon v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Edit User {{ item.firstname }} {{ item.lastname }}</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="errorMessage">
          <span v-html="errorMessage"></span>
        </v-alert>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Firstname"
                v-model="item.firstname"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Lastname"
                v-model="item.lastname"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Email"
                v-model="item.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Password"
                v-model="item.password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" text :loading="loading" @click="updateItem">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['item'],
  data: () => ({
    dialog: false,
    loading: false,
    errorMessage: ''
  }),
  methods: {
    updateItem () {
      this.loading = true
      this.errorMessage = ''
      this.$http.patch(
        this.item['@id'],
        this.item,
        {
          headers: { 'Content-Type': 'application/merge-patch+json' }
        }
      )
        .then(() => {
          this.dialog = false
          this.$emit('refresh')
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
